var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"countdown d-print-none"},[_c('div',{staticClass:"text-white p-2"},[_c('span',{staticClass:"countdown__info"},[_vm._v(_vm._s(_vm.$t('general.countdown_info'))+": ")]),_c('span',{staticClass:"countdown__duration"},[_vm._v(_vm._s(_vm.duration_minutes)+":"+_vm._s(_vm.duration_seconds))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }